import { Customer } from "../../../domain/model/Customer";
import { Order } from "../../../domain/model/Order";
import { Response } from "../../api/Response";
import NetworkApi from "../../network/NetworkApi";
import { CustomerRepository } from "./CustomerRepository";

export class CustomerRepositoryImpl implements CustomerRepository {
  apiService: NetworkApi;

  constructor(datasource: NetworkApi) {
    this.apiService = datasource;
  }
  getAll(skip?: number, limit?: number): Promise<Response<Array<Customer>>> {
    return this.apiService.getCustomers(skip, limit);
  }
  getById(id: string): Promise<Response<Customer>> {
    return this.apiService.getCustomerById(id);
  }
  search(search: string): Promise<Response<Array<Customer>>> {
    return this.apiService.searchCustomers(search);
  }
  getOrders(
    customerId: string,
    skip?: number,
    limit?: number
  ): Promise<Response<Array<Order>>> {
    return this.apiService.getCustomerOrders(customerId, skip, limit);
  }
}
